






















import { User } from '@/shared/user';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class UserDetails extends Vue {
    @Prop({ required: true }) private user!: User;

    @Watch('$validator.errors', { deep: true })
    private onErrorsChanged(): void {
        this.$emit('errors-changed', this.$validator.errors.any());
    }
}
